import React, { useCallback, Fragment } from "react";
import CompanyJoin from "../components/CompanyJoin";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import {
  jssPreset,
  StylesProvider,
  makeStyles,
} from "@material-ui/core/styles";
import { create } from "jss";
import jssTemplate from "jss-plugin-template";

import { useSelector, useDispatch } from "react-redux";

import {
  changeGender,
  changeName,
  changeBirthday,
  changeLunar,
  changePhone,
  changeResidence,
  changePersonal,
  changeMarketing,
  changeThirdParty,
  changeSmsYn,
  changeKakaoYn,
  changeAdYn,
  changeRecommend,
  changePartDiv,
  changePartNo,
  changeTotalAllYn,
  changeAllYn,
  changeMemberShip,
  changeCompanyName,
  changeCompanySite,
} from "../modules/join";

const useStyles = makeStyles({
  joinRoot: ` height:75vh;
          margin:0 auto;
  `,
  joinRootBox: `
  overflow:auto;
  max-width:800px;
  height:70vh;
  margin:0 auto;
  padding-left : 15px;
  padding-right : 15px;
  padding-bottom:10px;
  font-size:14px;
  color:#000;
  background:#fff;
  -webkit-box-sizing:border-box;
  box-sizing:border-box;
  overflow-y:auto;
  `,

  "@media screen and (min-width:600px)": {
    joinRoot: ` height:69vh;
  `,
    joinRootBox: `max-width:520px;
    margin:0 auto;
    height:68vh;
    padding-left : 50px;
    padding-right : 50px;
    padding-top:20px;
    padding-bottom:20px;
    border-radius:2px;
    overflow-y:auto;`,
  },
});

function Child(props) {
  const classes = useStyles();
  const Join = useSelector((state) => state.join);

  const dispatch = useDispatch();

  const onChangeName = useCallback(
    (name) => dispatch(changeName(name)),
    [dispatch]
  );

  const onChangeBirthday = useCallback(
    (birthday) => dispatch(changeBirthday(birthday)),
    [dispatch]
  );
  const onChangeLunar = useCallback(
    (lunar) => dispatch(changeLunar(lunar)),
    [dispatch]
  );
  const onChangePhone = useCallback(
    (phone) => dispatch(changePhone(phone)),
    [dispatch]
  );
  const onChangeGender = useCallback(
    (gender) => dispatch(changeGender(gender)),
    [dispatch]
  );
  const onChangeResidence = useCallback(
    (residence) => dispatch(changeResidence(residence)),
    [dispatch]
  );
  const onChangeRecommend = useCallback(
    (recommend) => dispatch(changeRecommend(recommend)),
    [dispatch]
  );
  const onChangeMemberShip = useCallback(
    (memberShip) => dispatch(changeMemberShip(memberShip)),
    [dispatch]
  );
  const onChangePersonal = useCallback(
    (personal) => dispatch(changePersonal(personal)),
    [dispatch]
  );
  const onChangeMarketing = useCallback(
    (marketing) => dispatch(changeMarketing(marketing)),
    [dispatch]
  );
  const onChangeThirdParty = useCallback(
    (thirdParty) => dispatch(changeThirdParty(thirdParty)),
    [dispatch]
  );
  const onChangeSmsYn = useCallback(
    (thirdParty) => dispatch(changeSmsYn(thirdParty)),
    [dispatch]
  );
  const onChangeKakaoYn = useCallback(
    (thirdParty) => dispatch(changeKakaoYn(thirdParty)),
    [dispatch]
  );
  const onChangeAdYn = useCallback(
    (thirdParty) => dispatch(changeAdYn(thirdParty)),
    [dispatch]
  );
  const onChangePartDiv = useCallback(
    (partDiv) => dispatch(changePartDiv(partDiv)),
    [dispatch]
  );
  const onChangePartNo = useCallback(
    (partNo) => dispatch(changePartNo(partNo)),
    [dispatch]
  );
  const onChangeAllYn = useCallback(
    (allYn) => dispatch(changeAllYn(allYn)),
    [dispatch]
  );
  const onChangeTotalAllYn = useCallback(
    (totalAllYn) => dispatch(changeTotalAllYn(totalAllYn)),
    [dispatch]
  );
  const onChangeCompanyName = useCallback(
    (name) => dispatch(changeCompanyName(name)),
    [dispatch]
  );
  const onChangeCompanySite = useCallback(
    (name) => dispatch(changeCompanySite(name)),
    [dispatch]
  );
  return (
    <div className={classes.joinRoot}>
      <div className={classes.joinRootBox}>
        <CompanyJoin
          Join={Join}
          onChangeName={onChangeName}
          onChangeBirthday={onChangeBirthday}
          onChangeLunar={onChangeLunar}
          onChangePhone={onChangePhone}
          onChangeGender={onChangeGender}
          onChangeResidence={onChangeResidence}
          onChangeRecommend={onChangeRecommend}
          onChangeMemberShip={onChangeMemberShip}
          onChangePersonal={onChangePersonal}
          onChangeMarketing={onChangeMarketing}
          onChangeThirdParty={onChangeThirdParty}
          onChangeSmsYn={onChangeSmsYn}
          onChangeKakaoYn={onChangeKakaoYn}
          onChangeAdYn={onChangeAdYn}
          partCode={props.match.params.partcode}
          onChangePartDiv={onChangePartDiv}
          onChangePartNo={onChangePartNo}
          onChangeAllYn={onChangeAllYn}
          onChangeTotalAllYn={onChangeTotalAllYn}
          onChangeCompanyName={onChangeCompanyName}
          onChangeCompanySite={onChangeCompanySite}
        ></CompanyJoin>
      </div>
    </div>
  );
}
function JoinContainer2({ match }) {
  const jss = create({
    plugins: [jssTemplate(), ...jssPreset().plugins],
  });

  return (
    <Fragment>
      <Header title="신원 특판 멤버십 가입 신청서(직장인 혜택)" />
      <StylesProvider jss={jss}>
        <Child match={match} />
      </StylesProvider>
      <Footer />
    </Fragment>
  );
}

export default JoinContainer2;
